import { TagType } from '../../__generated__/queries-web';

export const allowedTagTypes = [
  TagType.Person,
  TagType.Tag,
  TagType.Company,
  TagType.Destination,
];
